import { render, staticRenderFns } from "./CustomFileField.vue?vue&type=template&id=1c2bdc6a&"
import script from "./CustomFileField.vue?vue&type=script&lang=js&"
export * from "./CustomFileField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports